import { FC } from 'react';

import { ProgressWrapper } from './Wrapper';
import { ProgressButtonProps } from './types';

const ProgressButton: FC<ProgressButtonProps> = ({ variant, totalFiles, currentUploadIndex, progressValue }) => {
  const showCounter = totalFiles > 1;
  const counter = showCounter ? `(${currentUploadIndex}/${totalFiles})` : null;

  return (
    <ProgressWrapper progressVariant={variant} variant="gray-system" size="large" value={progressValue}>
      <span>
        <i>{progressValue}</i> Uploading {counter}
      </span>
    </ProgressWrapper>
  );
};

export default ProgressButton;
